import { ATTRIBUTION_TOKEN_QUERY_PARAM } from '@utils/constants';

export const getAttributeToken = () => {
  return new URLSearchParams(window.location.search).get(
    ATTRIBUTION_TOKEN_QUERY_PARAM
  );
};
